<template>
  <div class="container">
    <table></table>
    <van-list
      v-model="listloading"
      :finished="listfinished"
      finished-text="没有更多啦"
      :immediate-check="false"
      @load="listload_more"
    >
      <div
        class="list"
        v-for="(item, index) in list"
        :key="index"
        @click="$router.push('/detail?id=' + item.id)"
      >
        <div class="left">
          <div>
            <p class="desc">主题</p>
            <p class="title">{{ item.title }}</p>
          </div>
          <div>
            <p class="desc">时间</p>
            <p class="date">
              {{ item.starttime_fmt }} - {{ item.endtime_fmt }}
            </p>
          </div>
        </div>
        <div
          class="bt"
          v-if="item.btn == 2"
          @click.stop="sign(item.id, 'in', item.needgis)"
        >
          签到
        </div>
        <div
          class="bt"
          v-else-if="item.btn == 3"
          style="color: #1646c0; background: white; border: 1px solid #1646c0"
          @click.stop="sign(item.id, 'out', item.needgis)"
        >
          签离
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { queryLocation } from "../assets/js/common";
export default {
  name: "signlist",
  data() {
    return {
      list: [],
      lat: "", //用户地址
      lon: "",
      lattarget: "", //目标地址
      lngtarget: "",
      listloading: false,
      listfinished: false,
      listpage: 1,
    };
  },
  mounted() {
    this.getqueryLocation();
    this.init();
  },
  methods: {
    init() {
      this.list = [];
      this.listpage = 1;
      this.listfinished = false;
      this.listloading = false;
      this.$axios
        .post(
          "/api/task/todo_list",
          this.qs.stringify({
            page: this.listpage,
          })
        )
        .then((res) => {
          //console.log(res);
          if (res.data.code != 0) {
            this.$toast(res.data.msg);
          } else {
            this.list = res.data.data.list;
          }
        });
    },
    listload_more() {
      this.listpage += 1;
      setTimeout(() => {
        this.$axios({
          method: "post",
          url: "/api/task/todo_list",
          data: this.qs.stringify({
            page: this.listpage,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            this.list = this.list.concat(res.data.data.list);
          }
          this.listloading = false;
          if (res.data.data.list.length == 0) {
            //数据全部加载完成
            this.listfinished = true;
          } else {
            this.listfinished = false;
          }
        });
      }, 500);
    },
    //签到签离相关
    getRad(d) {
      return (d * Math.PI) / 180.0; //经纬度转换成三角函数中度分表形式。
    },
    getFlatternDistance(lat1, lng1, lat2, lng2) {
      lat1 = parseFloat(lat1);
      lat2 = parseFloat(lat2);
      lng1 = parseFloat(lng1);
      lng2 = parseFloat(lng2);
      var f = this.getRad((lat1 + lat2) / 2);
      var g = this.getRad((lat1 - lat2) / 2);
      var l = this.getRad((lng1 - lng2) / 2);
      var sg = Math.sin(g);
      var sl = Math.sin(l);
      var sf = Math.sin(f);
      var PI = Math.PI;
      var EARTH_RADIUS = 6378137.0;
      var s, c, w, r, d, h1, h2;
      var a = EARTH_RADIUS;
      var fl = 1 / 298.257;

      sg = sg * sg;
      sl = sl * sl;
      sf = sf * sf;

      s = sg * (1 - sl) + (1 - sf) * sl;
      c = (1 - sg) * (1 - sl) + sf * sl;

      w = Math.atan(Math.sqrt(s / c));
      r = Math.sqrt(s * c) / w;
      d = 2 * w * a;
      h1 = (3 * r - 1) / 2 / c;
      h2 = (3 * r + 1) / 2 / s;

      return d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
    },
    getqueryLocation() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      var that = this;
      let appId = "2312";
      zjyapi.init({
        appId: appId,
        error: function (code, ret) {
          //失败回调,默认
          that.$toast.clear();
          that.$toast("初始化失败");
        },
        success: function success(ret) {
          queryLocation().then((res) => {
            that.$toast.clear();
            that.lat = res.latitude;
            that.lon = res.longitude;
          });
        },
      });
    },
    sign(id, status, need) {
      /* if (this.skeloading) {
        this.$toast("正在获取您的位置，请稍候");
        return;
      } */
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      if (status == "in") {
        //点击签到
        let distance = this.getFlatternDistance(
          this.lattarget,
          this.lngtarget,
          this.lat,
          this.lon
        );
        console.log(this.lattarget, this.lngtarget, this.lat, this.lon);
        console.log("distance:");
        console.log(distance);
        if (need == 1 && distance > 1000) {
          this.$toast.clear();
          this.$toast("您离目标地点距离太远");
        } else {
          this.$axios({
            method: "post",
            url: "/api/task/signin",
            data: this.qs.stringify({
              id: id,
            }),
          }).then((res) => {
            //console.log(res.data);
            this.$toast.clear();
            if (res.data.code == 0) {
              //this.$toast("签到成功");
              Dialog({ message: "签到成功" });
              this.init();
            } else {
              this.$toast(res.data.msg);
            }
          });
        }
      }
      if (status == "out") {
        //点击签离
        let distance = this.getFlatternDistance(
          this.lattarget,
          this.lngtarget,
          this.lat,
          this.lon
        );
        console.log(this.lattarget, this.lngtarget, this.lat, this.lon);
        console.log("distance:");
        console.log(distance);
        if (distance > 1000 && need == 1) {
          this.$toast.clear();
          this.$toast("您离目标地点距离太远");
        } else {
          this.$axios({
            method: "post",
            url: "/api/task/signout",
            data: this.qs.stringify({
              id: id,
            }),
          }).then((res) => {
            console.log(res.data);
            this.$toast.clear();
            if (res.data.code == 0) {
              Dialog({ message: res.data.msg });
              this.init();
            } else {
              this.$toast(res.data.msg);
            }
          });
        }
      }
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f5f6f7;
}
.list {
  background: white;
  border-radius: 8px;
  padding: 10px;
  margin: 10px;
  display: flex;
}
.left div {
  display: flex;
  font-size: 14px;
  line-height: 22px;
  padding: 5px 0;
}
.desc {
  color: #999999;
  padding-right: 10px;
  white-space: nowrap;
}
.title {
  color: #333;
  font-weight: bold;
}
.date {
  color: #333;
}
.bt {
  color: white;
  background: #1646c0;
  font-size: 12px;
  text-align: center;
  width: 54px;
  border-radius: 14px;
  line-height: 28px;
  height: 28px;
  align-self: center;
  margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/signlist.vue